type Position = 'tl' | 'tr';

export function Crosshair({ position }: { position: Position }) {
  return (
    <svg
      className={`pn-crosshair pn-crosshair-${position}`}
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      aria-hidden="true"
    >
      <path d="M0 7h5M9 7h5M7 0v5M7 9v5" />
      <circle cx="7" cy="7" r="1.5" />
    </svg>
  );
}

export function SectionCrosshairs() {
  return (
    <>
      <Crosshair position="tl" />
      <Crosshair position="tr" />
    </>
  );
}
